import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';
import { KoReasonFieldsModel } from '../../type/entities/ko-reason-type';

const ENDPOINT = '/ko-reasons';

export class KoReasonService extends RestServiceConnection {

    listKoReasons = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listKoReasonsForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-ko-reasons-for-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getKoReasonById = async (koReasonId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { koReasonId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    createKoReason = async (koReason: KoReasonFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: koReason,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editKoReason = async (koReason: KoReasonFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: koReason,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteKoReason = async (koReasonId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { koReasonId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteMultiKoReasons = async (koReasonIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { koReasonIds }
        }, true);
        return this;
    }
}
